module.exports = __webpack_public_path__ + "static/a-xx-009-art-1c4f7d9c3a121a9211a2faf0d4dfe542.jpg";